import { Box, Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';
import { theme } from 'theme';
import BankIcon from 'assets/icons/Bank.svg?react';
import AttentionWarning from 'assets/icons/AttentionWarning.svg?react';
import { formatEnum } from 'utils/stringUtils';

const styles = {
  container: {
    paddingLeft: theme.spacing(2),
  },
  icon: {
    marginTop: theme.spacing(2),
  },
  cardHeader: {
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
  card: {
    maxWidth: '90%',
    marginTop: theme.spacing(2),
  },
};

type Props = {
  account: string;
  portfolio: string;
  isNewBrRequired: boolean;
};
export const AccountInformation = ({ account, portfolio, isNewBrRequired }: Props) => {
  return (
    <Card data-testid="account-information" sx={styles.card} square>
      <Grid container sx={styles.container}>
        <BankIcon style={styles.icon} />
        <CardHeader
          title={'ACCOUNT INFORMATION'}
          titleTypographyProps={{ variant: 'subtitle1' }}
          sx={styles.cardHeader}
        />
      </Grid>
      <CardContent>
        <Grid container direction={'row'}>
          <Grid item container direction={'column'} xs={3}>
            <Grid item>
              <Typography variant={'caption'}>Account</Typography>
            </Grid>
            <Grid item>
              <Box display={'flex'}>
                <Box style={{ marginRight: theme.spacing(1) }}>
                  <Typography>{formatEnum(account)}</Typography>
                </Box>
                {isNewBrRequired && <AttentionWarning style={{ padding: theme.spacing(0.3) }} />}
              </Box>
            </Grid>
          </Grid>
          <Grid item container direction={'column'} xs={3}>
            <Grid item>
              <Typography variant={'caption'}>Portfolio</Typography>
            </Grid>
            <Grid item>
              <Typography>{portfolio}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
